import React, { useState, useEffect } from "react";
import axios from "../../../library/axios";
import { MySwal } from "../../../library/swal";
import Button from "react-bootstrap/Button";
import SelectAccreditation from "react-select";
import { getSlug, } from "../../../../src/config/routes/guards/slug";

const EditAccreditationComp = (props) => {
  // console.log(props?.survey)
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [IdMasterAkreditasi, setIdMasterAkreditasi] = useState({
    value: props?.survey?.IdMasterAkreditasi,
    label: props?.survey?.standards_accreditation?.Nama,
  });
  const [TglMulai, setTglMulai] = useState(props.survey.TglMulai);
  const [TglBerakhir, setTglBerakhir] = useState(props.survey.TglBerakhir);
  const [active, setactive] = useState(props.survey.active);
  const [SyncSelfAssessment, setSyncSelfAssessment] = useState(
    props.survey.SyncSelfAssessment
  );
  const [standardAccreditations, setstandardAccreditations] = useState([]);

  const fetchData = async () => {
    try {
      const options = {
        url: `/standards/list`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data)
      // return false
      setstandardAccreditations([]);
      data.map((d) =>
        setstandardAccreditations((standardAccreditations) => [
          ...standardAccreditations,
          {
            label: d.Nama,
            value: d.id,
          },
        ])
      );
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleCreate = () => {
    setLoading(true);
    setDisabled(true);

    const requestBody = {
      IdMasterAkreditasi: IdMasterAkreditasi.value,
      SyncSelfAssessment: SyncSelfAssessment,
      TglMulai: TglMulai,
      TglBerakhir: TglBerakhir,
      active: active,
    };
    // console.log(requestBody)
    // return false
    axios({
      url: `/accreditations/update/${props.survey.id}`,
      method: "PATCH",
      data: requestBody,
      headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
    })
      .then((res) => {
        // console.log(res)
        // return false
        if (res.status === 200) {
          MySwal.fire({
            icon: "success",
            title: "Success",
            text: "Successfully updated Accreditation!",
          });

          setLoading(false);
          setDisabled(false);

          props.close();
          props.fetch();
        }
      })
      .catch((err) => {
        setLoading(false);
        setDisabled(false);
        if (err !== "") {
          console.log(err?.response?.data?.message);
          MySwal.fire({
            icon: "error",
            title: "Oops, Error!",
            text: `${err?.response?.data?.message}`,
          });
        }
      });
  };

  return (
    <div>
      <div className="mb-3 row">
        <label htmlFor="user" className="col-sm-12 col-form-label required">
          Standard Akreditasi
        </label>
        <div className="col-12">
          <SelectAccreditation
            id="accreditation"
            value={IdMasterAkreditasi}
            onChange={setIdMasterAkreditasi}
            options={standardAccreditations}
            placeholder="Cari"
            isDisabled="disabled"
          />
        </div>
      </div>
      <div className="mb-3 row">
        <label htmlFor="TglMulai" className="col-sm-12 col-form-label required">
          Tgl Mulai Survei
        </label>
        <div className="col-12">
          <input
            type="date"
            className="form-control"
            id="TglMulai"
            onChange={(e) => setTglMulai(e.target.value)}
            value={TglMulai}
          />
        </div>
      </div>
      <div className="mb-3 row">
        <label
          htmlFor="TglBerakhir"
          className="col-sm-12 col-form-label required"
        >
          Tgl Berakhir Survei
        </label>
        <div className="col-12">
          <input
            type="date"
            className="form-control"
            id="TglBerakhir"
            onChange={(e) => setTglBerakhir(e.target.value)}
            value={TglBerakhir}
          />
        </div>
      </div>
      <div className="mb-5 row">
        <label
          htmlFor="active"
          className="col-sm-12 col-form-label required"
        >
          Active
        </label>
        <div className="col-12">
          <select
            className="form-control"
            onChange={(e) => setactive(e.target.value)}
            value={active}
          >
            <option value="" selected>
              - Pilih -
            </option>
            <option value="YES">Yes</option>
            <option value="NO">No</option>
          </select>
        </div>
      </div>
      <div className="mb-5 row">
        <label
          htmlFor="SyncSelfAssessment"
          className="col-sm-12 col-form-label required"
        >
          Import Self Assessment
        </label>
        <div className="col-12">
          <select
            className="form-control"
            onChange={(e) => setSyncSelfAssessment(e.target.value)}
            value={SyncSelfAssessment}
            disabled={true}
          >
            <option value="" selected>
              - Pilih -
            </option>
            <option value="Ya">Ya</option>
            <option value="Tidak">Tidak</option>
          </select>
          <small className="text-info">
            Pilih "Ya" jika akan melakukan Import Self Assessment dari SPEAK
            Online.
          </small>
        </div>
      </div>
      <div className="mt-5 row">
        <div className="col-12">
          <Button variant="danger" size="sm" onClick={() => props.close()}>
            Tutup
          </Button>
          &nbsp;
          <Button
            disabled={disabled}
            variant="success"
            size="sm"
            onClick={() => handleCreate()}
          >
            {loading === true ? "Mohon Tunggu.." : "Simpan"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EditAccreditationComp;
